<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="600px" :z-index="3000">
      <v-card v-if="!isFetching">
        <v-card-title>{{translater.__('Edit Route Group', 'routes')}}</v-card-title>
        <v-card-text>
          <v-container wrap>
            <v-flex xs12>
              <v-text-field
                :label="translater.__('RouteGroup', 'routes')"
                v-model="routegroupDisplayName"
              ></v-text-field>
              <small class="error" v-if="typeof error !== 'undefined'">{{error}}</small>
            </v-flex>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            flat
            @click.native="dialog = false"
          >{{translater.__('Close')}}</v-btn>
          <v-btn
            :disabled="!valid"
            color="blue darken-1"
            flat
            @click.native="updateRouteGroup()"
          >{{translater.__('Save')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: "EditRouteGroup",
  data() {
    return {
      mRoutegroupDisplayName: "",
      isFetching: false,
      error: undefined
    };
  },

  created() {
    this.isFetching = true;
    /*this.$nextTick(() => {
  				document.getElementsByClassName('v-dialog__content')[0].style.zIndex = 3000;
  			})*/
  },

  mounted() {
    this.$nextTick(() => {
      this.routegroupDisplayName = this.$store.getters[
        "routes/route"
      ].routegroupDisplayName;
      this.isFetching = false;
      document.getElementsByClassName(
        "v-dialog__content"
      )[0].style.zIndex = 3000;
    });
  },

  methods: {
    /*setRouteGroupDisplayName(e)
			{
				this.routegroupDisplayName = e.target.value
				console.log(this.routegroupDisplayName)
			}*/

    updateRouteGroup() {
      this.$store
        .dispatch("routes/updateRouteGroup", this.routegroupDisplayName)
        .then(res => {
          window.vm.$emit("routeAdded");
          //window.vm.$emit('routeGroupUpdated')

          this.$store.commit("routes/setEditRouteGroup", false);
          /*this.$store.dispatch('routes/setUpdatedRoute', res.data);
					//this.$store.dispatch('status/updateResources', 'routedata')

					//window.vm.$emit('routeNameUpdated')

					window.vm.$emit('updateRouteGroup') */
        })
        .catch(err => {
          console.error("#####", err);
        });
    }
  },

  computed: {
    dialog: {
      get() {
        return this.$store.getters["routes/editRouteGroup"];
      },

      set(value) {
        this.$store.commit("routes/setEditRouteGroup", value);
      }
    },

    translater: {
      get() {
        return this.$store.getters["translate/translater"];
      }
    },

    routegroupDisplayName: {
      get() {
        return this.mRoutegroupDisplayName;
      },

      set(value) {
        this.mRoutegroupDisplayName = value;
      }
    },

    valid: {
      get() {
        return (
          typeof this.routegroupDisplayName !== "undefined" &&
          this.routegroupDisplayName.trim() !== "" &&
          this.routegroupDisplayName !==
            this.$store.getters["routes/route"].routegroupDisplayName
        );
      }
    }
  }
};
</script>